
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 w-full z-50 shadow-md border-b border-blue-700" style={{ backgroundColor: '#0D1B2A' }}>
      <div className="w-full px-6">
        <div className="flex items-center justify-between h-20">
          {/* Guziki funkcyjne po lewej */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-blue-100 hover:text-blue-300 text-lg font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-blue-100 hover:text-blue-300 text-lg font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-blue-100 hover:text-blue-300 text-lg font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-blue-100 hover:text-blue-300 text-lg font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Contact
            </button>
          </nav>

          {/* Nazwa firmy na środku */}
          <div className="absolute left-1/2 transform -translate-x-1/2">
            <div className="text-3xl font-bold text-blue-100 tracking-wide">
              MGM RELO LTD
            </div>
          </div>

          {/* Logo po prawej - desktop */}
          <div className="hidden md:flex items-center">
            <img 
              src="https://static.readdy.ai/image/87505c603ef0feae3c12190971600621/f66559d8e1da71acba155dc2e3f39745.png"
              alt="MGM RELO Logo"
              className="h-16 w-auto"
            />
          </div>

          {/* Przycisk hamburger - mobile */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-12 h-12 flex items-center justify-center text-blue-100 hover:text-blue-300 cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-3xl`}></i>
          </button>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden border-t border-blue-700 py-6" style={{ backgroundColor: '#0D1B2A' }}>
            {/* Mobile logo */}
            <div className="mb-6 pb-6 border-b border-blue-700 text-center">
              <img 
                src="https://static.readdy.ai/image/87505c603ef0feae3c12190971600621/f66559d8e1da71acba155dc2e3f39745.png"
                alt="MGM RELO Logo"
                className="h-20 w-auto mx-auto"
              />
            </div>
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('home')}
                className="text-left text-blue-100 hover:text-blue-300 text-lg font-medium py-3 cursor-pointer whitespace-nowrap"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="text-left text-blue-100 hover:text-blue-300 text-lg font-medium py-3 cursor-pointer whitespace-nowrap"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="text-left text-blue-100 hover:text-blue-300 text-lg font-medium py-3 cursor-pointer whitespace-nowrap"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-left text-blue-100 hover:text-blue-300 text-lg font-medium py-3 cursor-pointer whitespace-nowrap"
              >
                Contact
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}